import {
  GET_PROCESS_OPTIONS_FULFILLED,
  GET_PROCESS_OPTIONS_LIST,
  GET_PROCESS_OPTIONS_LIST_FULFILLED,
  GET_PROCESS_OPTIONS_PENDING,
  SELECT_PROCESS_OPTIONS,
  CREATE_PROCESS_OPTIONS_PENDING,
  CREATE_PROCESS_OPTIONS_FULFILLED,
  DELETE_PROCESS_OPTIONS_FULFILLED,
  SET_PROCESS_OPTIONS_LOADING,
  ProcessOptionActionTypes,
  ProcessOptionState,
} from './processOption.types';

const initialState: ProcessOptionState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function processOptionReducer(
  state = initialState,
  action: ProcessOptionActionTypes,
): ProcessOptionState {
  switch (action.type) {
    // case GET_PROCESS_OPTIONS_FULFILLED:
    //   return { ...state, entities: action.payload.data.data || [] };

    case GET_PROCESS_OPTIONS_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_PROCESS_OPTIONS_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };
    case GET_PROCESS_OPTIONS_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_PROCESS_OPTIONS_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_PROCESS_OPTIONS:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_PROCESS_OPTIONS_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_PROCESS_OPTIONS_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_PROCESS_OPTIONS_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_PROCESS_OPTIONS_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
